import { ISearchPromosV2ResponseSchema } from '../../repositories/newbuilding-promos/entities/search_promos_v2/SearchPromosV2ResponseSchema';
import { ITypedReduxAction } from '../../types/redux/actionType';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export enum EPaginationActionTypes {
  Request = 'PAGINATION/REQUEST',
  Success = 'PAGINATION/SUCCESS',
  Failure = 'PAGINATION/FAILURE',
}

export type TPaginationSuccess = ITypedReduxAction<EPaginationActionTypes.Success, ISearchPromosV2ResponseSchema>;
export type TPaginationRequest = ITypedReduxAction<EPaginationActionTypes.Request>;
export type TPaginationFailure = ITypedReduxAction<EPaginationActionTypes.Failure>;

/**
 * Redux action, который записывает в store список акций
 * @param promos ISearchPromosV2ResponseSchema
 */
export const paginationSuccess: (promos: ISearchPromosV2ResponseSchema) => TPaginationSuccess = actionGenerator<
  EPaginationActionTypes.Success,
  ISearchPromosV2ResponseSchema
>(EPaginationActionTypes.Success);

export const paginationRequest: () => TPaginationRequest = actionGenerator<EPaginationActionTypes.Request>(
  EPaginationActionTypes.Request,
);

export const paginationFailure: () => TPaginationFailure = actionGenerator<EPaginationActionTypes.Failure>(
  EPaginationActionTypes.Failure,
);

export type TPaginationActionTypes = TPaginationRequest | TPaginationSuccess | TPaginationFailure;
